import React, {useEffect, useRef, useState} from 'react'
import {Pagination} from '../../../components/Pagination'
import {Tooltip} from 'react-tooltip'
import {useAuth} from '../../modules/auth'
import {useFormik} from 'formik'
import {ModeleDemandeDemontage} from '../../../components/Models'
import {
  getDemandeDemontage,
  getDemontageStatut,
  getTypePieceDemandeDemontage,
} from '../../../components/requests'
import moment from 'moment/moment'
import {DateInput} from '../../../components/inputs/DateInput'
import {KTIcon} from '../../../_metronic/helpers'
import {toast} from 'react-toastify'
import {DemandeDemontageValidationModal} from './DemandeDemontageValidationModal'
import {DemandeDemontageModal} from '../demontage/DemandeDemontageModal'
import {DemandeDemontageAnnulationModal} from './DemandeDemontageAnnulationModal'
import Select from 'react-select'
import {Link, useNavigate, useSearchParams} from 'react-router-dom'
import {shouldDisplayFonctionnalite} from '../../../components/helpers'
import {renderDemontageStatut} from '../../../components/renders'
import ClientDemandeMessage from '../suggestion/Components/ClientDemandeMessage'

const DemandeDemontageListPage = () => {
  const [params] = useSearchParams()
  const {currentUser} = useAuth()
  const navigate = useNavigate()
  const [spinner, setSpinner] = useState(false)
  const [data, setData] = useState<Array<ModeleDemandeDemontage>>([])
  const [nombreDePages, setNombreDePages] = useState<number>(0)
  const [totalPages, setTotalPages] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(() => {
    const sessionPage = sessionStorage.getItem('demontagePage')
    return sessionPage ? Number(sessionPage) : 1
  })
  const [searchPage, setSearchPage] = useState<string>(() => {
    const sessionSearch = sessionStorage.getItem('searchPage')
    return sessionSearch ?? params?.get('vehicule') ?? ''
  })
  const [numero, setNumero] = useState<string | undefined>('')
  const [isSearch, setIsSearch] = useState(false)
  const [dateDebut, setDateDebut] = useState<string | null>('')
  const [dateFin, setDateFin] = useState<string | null>('')
  const [demontageStatut, setDemontageStatut] = useState<any | undefined>([])
  const [searchStatut, setSearchStatut] = useState<string>(
    () => sessionStorage.getItem('statut') || ''
  )
  const [activateSearch, setActivateSearch] = useState<boolean>(false)
  const [openDemandeDemontageValidationModal, setOpenDemandeDemontageValidationModal] =
    useState<boolean>(false)
  const [openDemandeDemontageModifModal, setOpenDemandeDemontageModifModal] =
    useState<boolean>(false)
  const [openDemandeDemontageAnnulationModal, setOpenDemandeDemontageAnnulationModal] =
    useState<boolean>(false)
  const [demandeDemontageId, setDemandeDemontageId] = useState<Number | undefined>(undefined)
  const [demandeDemontage, setDemandeDemontage] = useState<ModeleDemandeDemontage | undefined>()
  const [demandeClient, setDemandeClient] = useState<null | number>(null)
  const [vehiculeId, setVehiculeId] = useState<Number | undefined>(undefined)
  const [typePiece, setTypePiece] = useState<any | undefined>([])
  const [valueTypePiece, setValueTypePiece] = useState<any>([])
  const [searchTypePiece, setSearchTypePiece] = useState<string>(
    () => sessionStorage.getItem('typePieceQuery') || ''
  )
  const [marqueModele, setMarqueModele] = useState<string | undefined>('')
  const isFirstLoad = useRef(true)

  // Récupération de type piece
  const getTypePieceDemandeDemontageData = () => {
    getTypePieceDemandeDemontage().then((typePieceRequest) => {
      if (typePieceRequest?.status === 200) {
        if (typePieceRequest?.data !== undefined) {
          const transformedData = typePieceRequest.data.map((item) => ({
            typePiece: item.id,
            value: item.nom,
            label: item.nom,
          }))
          setTypePiece([...transformedData])
        }
      }
    })
    const lastTypePiece = sessionStorage.getItem('typePiece')
    if (lastTypePiece !== null) {
      setValueTypePiece(JSON.parse(lastTypePiece))
    }
  }

  const handleTypePieceChange = async (data) => {
    // Si il n'y a pas de valeur dans data
    if (data.length === 0) {
      // retirer la valeur choisi de modele
      setSearchTypePiece('')
      setValueTypePiece([])

      // nettoyer formik pour la requete
      formik.setFieldValue('typePiece', '')
      sessionStorage.removeItem('typePiece')
      sessionStorage.removeItem('typePieceQuery')
    } else {
      // definir la valeur choisi de modele
      setValueTypePiece(data)

      // préparer la valeur à placer dans formik en cas de selection multiple
      const typePieceFiltered = data
        ? data
            .map((type_piece) => type_piece.value)
            .filter((value, index, self) => self.indexOf(value) === index)
            .join(',')
        : ''
      formik.setFieldValue('typePiece', typePieceFiltered)
      sessionStorage.setItem('typePiece', JSON.stringify(data))
      sessionStorage.setItem('typePieceQuery', JSON.stringify(typePieceFiltered))
    }
    setIsSearch(true)
    //  setCurrentPage(1)
    formik.submitForm()
  }

  const getDemandeDemontageData = () => {
    setSpinner(true)
    const lastTypePiece = sessionStorage.getItem('typePieceQuery') ?? ''
    const searchTypePieceValue = lastTypePiece ? JSON.parse(lastTypePiece) : searchTypePiece
    const lastDateDebut = sessionStorage.getItem('dateDebut')
    const lastDateFin = sessionStorage.getItem('dateFin')
    getDemandeDemontage(
      !isSearch ? currentPage : 1,
      searchPage,
      searchStatut,
      dateDebut,
      dateFin,
      searchTypePieceValue
    ).then((demandeRequest) => {
      setNombreDePages(demandeRequest?.pages)
      setTotalPages(demandeRequest?.total)
      setCurrentPage(demandeRequest?.page)
      setSearchPage(demandeRequest?.search)
      setDateDebut(demandeRequest?.dateDebut)
      setDateFin(demandeRequest?.dateFin)
      setDateDebut(lastDateDebut ?? '')
      setDateFin(lastDateFin ?? '')
      if (demandeRequest?.data !== undefined) {
        setData(demandeRequest?.data)
      }
      sessionStorage.setItem('demontagePage', String(demandeRequest?.page))
      setSpinner(false)
      setIsSearch(false)
    })
  }

  // Récupération des status de demontages
  const getDemontageStatutData = () => {
    getDemontageStatut().then((demontageStatutRequest) => {
      if (demontageStatutRequest?.status === 200) {
        if (demontageStatutRequest?.data !== undefined) {
          const transformedData = demontageStatutRequest.data.map((item) => ({
            value: item.code,
            label: item.libelle,
          }))
          setDemontageStatut([...transformedData])
        }
      }
    })
    const lastStatut = sessionStorage.getItem('statut')
    if (lastStatut !== null) {
      setSearchStatut(lastStatut)
      //formik.setFieldValue('statut', lastStatut)
    }
  }

  useEffect(() => {
    if (isFirstLoad.current) {
      // Au premier chargement, récupérer les dates depuis sessionStorage
      const storedDateDebut = sessionStorage.getItem('dateDebut')
      const storedDateFin = sessionStorage.getItem('dateFin')
      if (storedDateDebut) setDateDebut(storedDateDebut)
      if (storedDateFin) setDateFin(storedDateFin)
      isFirstLoad.current = false
      return
    }
    // Ensuite, mettre à jour le sessionStorage selon les changements de l'utilisateur
    if (dateDebut) {
      sessionStorage.setItem('dateDebut', dateDebut)
    } else {
      sessionStorage.removeItem('dateDebut')
    }
    if (dateFin) {
      sessionStorage.setItem('dateFin', dateFin)
    } else {
      sessionStorage.removeItem('dateFin')
    }
    if (searchPage !== '') {
      sessionStorage.setItem('searchPage', searchPage)
    } else {
      sessionStorage.removeItem('searchPage')
    }
    // Desactivé la recherche si les deux dates sont vides et l'activé si l'une d'elle a une valeur
    if (dateDebut === '' && dateFin === '' && searchPage === '') {
      setActivateSearch(false)
      setIsSearch(false)
      if (currentPage !== 1) {
        setCurrentPage(1)
      } else {
        getDemandeDemontageData()
      }
    } else if (searchPage.length > 0) {
      setActivateSearch(true)
    } else if (dateDebut !== '' || dateFin !== '') {
      setActivateSearch(true)
      // Affiché une toast si dateFin est inférieur à dateDebut ou si dateFin n'a pas de valeur
      if (dateDebut !== null && dateFin !== null && dateFin < dateDebut) {
        if (dateFin !== '') {
          toast.warning('Veuillez saisir une date de début antérieure à la date de fin.')
          setActivateSearch(false)
        }
      }
    } else {
      setActivateSearch(false)
    }
  }, [dateDebut, dateFin, searchPage])

  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false
      return
    }
    getDemandeDemontageData()
  }, [currentPage, searchStatut, searchTypePiece])

  useEffect(() => {
    getDemontageStatutData()
    getTypePieceDemandeDemontageData()
  }, [])

  const formik = useFormik({
    initialValues: {
      allSearch: params?.get('vehicule') ?? '',
      statut: sessionStorage.getItem('statut') || '',
      typePiece: '',
    },
    onSubmit: (values, {setSubmitting}) => {
      setIsSearch(true)
      setSearchStatut(values.statut)
      // setSearchPage(values.allSearch)
      setIsSearch(true)
      setSearchTypePiece(values.typePiece)
    },
  })

  const OnchangeStatus = (value) => {
    formik.setFieldValue('statut', value)
    setIsSearch(true)
    sessionStorage.setItem('statut', value)
    //  setCurrentPage(1)
    formik.submitForm()
  }

  const dateIntervalSearch = () => {
    if (activateSearch) {
      // setCurrentPage(1)
      getDemandeDemontageData()
    }
  }
  // Style du select pour les filtres marque et modèle
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: '45px',
      minWidth: '200px',
      backgroundColor: 'transparent',
    }),
  }

  const showDemandeDemontageValidationModal = (demandeDemontageId: number | undefined) => {
    setOpenDemandeDemontageValidationModal(true)
    setDemandeDemontageId(demandeDemontageId)
  }

  const toggleShowDemandeDemontageValidationModal = (val: boolean) => {
    setOpenDemandeDemontageValidationModal(val)
  }

  const showDemandeDemontageModifModal = (
    demandeDemontageId: number | undefined,
    numeroVehicule: string | undefined,
    marqueModele: string | undefined,
    demandeDemontage: ModeleDemandeDemontage | undefined,
    demandeClientId: number | null
  ) => {
    setOpenDemandeDemontageModifModal(true)
    setDemandeDemontageId(demandeDemontageId)
    setNumero(numeroVehicule)
    setMarqueModele(marqueModele)
    setDemandeDemontage(demandeDemontage)
    setDemandeClient(demandeClientId)
  }

  const showDemandeDemontageAnnulationModal = (demandeDemontageId: number | undefined) => {
    setOpenDemandeDemontageAnnulationModal(true)
    setDemandeDemontageId(demandeDemontageId)
  }

  const toggleShowDemandeDemontageModifModal = (val: boolean) => {
    setOpenDemandeDemontageModifModal(val)
  }

  const toggleShowDemandeDemontageAnnulationModal = (val: boolean) => {
    setOpenDemandeDemontageAnnulationModal(val)
  }

  // Redirection pour voir l'historique de la demande de démontage
  const viewHistory = (demandeId) => {
    navigate(`/demande-demontage/${demandeId}/historique`)
  }

  return (
    <>
      {/* begin::Row  */}
      <div className='row g-5 g-xl-8'>
        {/* begin::Col  */}
        <div className='col-lg-12 col-sm-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-8'>
            {/* begin::Header */}
            <div className='card-header border-0 pt-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bold fs-3 mb-1'>Demandes</span>
              </h3>
              {shouldDisplayFonctionnalite(currentUser, 'CREER DEMANDE DEMONTAGE') && (
                <div
                  className='card-toolbar'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  data-bs-trigger='hover'
                >
                  <Link to={`/demontage/liste`}>
                    <button type='button' className='btn btn-light-primary'>
                      <KTIcon iconName='plus' className='fs-3' />
                      Créer une demande
                    </button>
                  </Link>
                </div>
              )}
            </div>
            {shouldDisplayFonctionnalite(currentUser, 'VOIR DEMANDE DEMONTAGE') && (
              <>
                {/* debut champs recherche */}
                <form className='card-header border-0 pt-5 pb-5' onSubmit={formik.handleSubmit}>
                  <div className='col-lg-2 col-sm-12'>
                    <select
                      name='statut'
                      id='statut'
                      className='form-select form-select-solid form-select-lg fw-bold'
                      value={searchStatut}
                      onChange={(e) => OnchangeStatus(e.target.value)}
                    >
                      <option value=''>Statut</option>
                      {demontageStatut.length ? (
                        demontageStatut.map((dm_statut, index) => {
                          return (
                            <option
                              key={dm_statut.id || dm_statut.value || index}
                              value={dm_statut?.value}
                            >
                              {dm_statut?.label}
                            </option>
                          )
                        })
                      ) : (
                        <option value=''>Aucun statut trouvé</option>
                      )}
                    </select>
                  </div>
                  <div className='col-lg-2 col-sm-12'>
                    <DateInput
                      fieldName='dateDebut'
                      inputClassName='form-control'
                      value={dateDebut}
                      setter={setDateDebut}
                      formik={formik}
                      placeholder='Date début'
                      customHeight={true}
                    />
                  </div>
                  <div className='col-lg-2 col-sm-12'>
                    <DateInput
                      fieldName='dateFin'
                      inputClassName='form-control'
                      value={dateFin}
                      setter={setDateFin}
                      formik={formik}
                      placeholder='Date fin'
                      customHeight={true}
                    />
                  </div>
                  <div className='col-lg-2'>
                    <Select
                      styles={customStyles}
                      className='react-select-styled react-select-solid react-select-lg'
                      classNamePrefix='react-select'
                      options={typePiece}
                      value={valueTypePiece}
                      placeholder='Type piece'
                      isClearable
                      isMulti
                      onChange={(data) => handleTypePieceChange(data)}
                    />
                  </div>
                  <div className='col-lg-3'>
                    <div className='form-group d-flex gap-3'>
                      <div className='input-group'>
                        <input
                          type='text'
                          className='form-control h-100'
                          defaultValue={searchPage}
                          name='allSearch'
                          placeholder='Recherche'
                          onChange={(e) => {
                            setSearchPage(e.target.value)
                            //  setCurrentPage(1)   // ⬅ reset pagination
                          }}
                        />
                      </div>
                      <button
                        type='submit'
                        className={`btn border-0 input-group-append h-45px ${
                          activateSearch ? 'btn-primary cursor-pointer' : 'btn-light disabled'
                        }`}
                        onClick={() => {
                          setIsSearch(true)
                          activateSearch && dateIntervalSearch()
                        }}
                      >
                        <i className='fas fa-search text-secondary fs-1'></i>
                      </button>
                    </div>
                  </div>
                </form>
                {/* fin champs recherche */}
                {/* end::Header */}
                <>
                  <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                      {/* begin::Table */}
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        {/* begin::Table head */}
                        <thead>
                          <tr className='fw-bold text-muted'>
                            <th className='min-w-40px'>Numéro</th>
                            <th className='min-w-100px'>Véhicule</th>
                            <th className='min-w-100px'>Marque/Modèle</th>
                            <th className='min-w-140px'>Date création</th>
                            <th className='min-w-140px'>Pièces demandées</th>
                            <th className='min-w-140px'>Demande</th>
                            <th className='min-w-140px'>Statut</th>
                            <th className='min-w-50px'>Demandeur</th>
                            <th className='min-w-140px'>Responsable parc</th>
                            <th className='min-w-40px text-end'>Actions</th>
                          </tr>
                        </thead>
                        {/* end::Table head */}
                        {/* begin::Table body */}
                        <tbody>
                          {spinner ? (
                            <tr>
                              <td colSpan={9} className='p-4 text-center h-500px'>
                                <span className='spinner-border spinner-border-sm align-middle ms-2 w-30px h-30px'></span>
                              </td>
                            </tr>
                          ) : data.length ? (
                            data.map((demande) => {
                              return (
                                <>
                                  <tr key={demande.id}>
                                    <td>
                                      <div className='d-flex align-items-center'>
                                        <div className='d-flex justify-content-start flex-column'>
                                          <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0 ms-2'>
                                            {demande?.id}
                                          </p>
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {demande?.vehicule?.numero}
                                      </p>
                                    </td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {demande?.vehicule?.vehicule?.modele?.marque?.nom}{' '}
                                        {demande?.vehicule?.vehicule?.modele?.nom}
                                      </p>
                                    </td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {moment(demande?.dateCreation).format('DD/MM/YYYY')}
                                      </p>
                                    </td>
                                    <td>
                                      {/*<p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>*/}
                                      {/*  {demande?.demandeTypePiece*/}
                                      {/*    ?.flat()*/}
                                      {/*    .map((piece) => piece?.typePiece?.nom )*/}
                                      {/*    .join(', ')}*/}
                                      {/*</p>*/}
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {demande?.demandeTypePiece
                                          ?.flat()
                                          .map((piece) =>
                                            piece?.typePiece
                                              ? piece?.typePiece?.nom
                                              : `${piece?.typePieceHn} [HN]`
                                          )
                                          .join(', ')}
                                      </p>
                                    </td>
                                    <td>
                                      <span>
                                        {
                                          demande?.demandeTypePiece
                                            ?.flat()
                                            .filter((piece) => piece?.clientDemande != null) // Filtre les pièces où clientDemande est non null
                                            .reduce((acc, piece) => {
                                              // Vérifie si l'idDemande existe déjà dans l'accumulateur
                                              const existing = acc.find(
                                                (item) =>
                                                  item.clientDemande?.id ===
                                                  piece?.clientDemande?.id
                                              )
                                              if (existing) {
                                                // Si un idDemande existe déjà, on n'ajoute pas la pièce à un autre élément
                                                return acc
                                              }
                                              // Si l'idDemande n'existe pas encore, on l'ajoute à l'accumulateur
                                              acc.push(piece)
                                              return acc
                                            }, []) // Réduit à un tableau unique d'éléments sans doublons sur l'idDemande
                                            .map((piece) => (
                                              <a
                                                key={piece?.clientDemande?.id}
                                                href={`/demandes/${piece?.clientDemande?.client?.id}/traitement/${piece?.clientDemande?.id}`}
                                                target='_blank'
                                                rel='noopener noreferrer'
                                              >
                                                {piece?.clientDemande?.id}
                                              </a>
                                            ))
                                            .reduce((acc, curr, index) => {
                                              if (index === 0) {
                                                return [curr] // Pas de virgule avant le premier élément
                                              }
                                              return [...acc, ', ', curr] // Ajoute une virgule entre les éléments
                                            }, []) // Initialise avec un tableau vide
                                        }
                                      </span>
                                    </td>
                                    <td>{renderDemontageStatut(demande?.statut?.libelle)}</td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {demande?.demandePar?.nom} {demande?.demandePar?.prenom}
                                      </p>
                                    </td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {demande?.validePar?.nom} {demande?.validePar?.prenom}
                                      </p>
                                    </td>

                                    <td>
                                      <div className='d-flex justify-content-end align-items-center flex-shrink-0 gap-1'>
                                        {(demande?.commentaire ||
                                          demande?.commentaireValidation ||
                                          demande?.commentaireModification ||
                                          demande?.commentaireAnnulation) && (
                                          <ClientDemandeMessage
                                            demandeId={null}
                                            demontage={demande}
                                            readOnly={true}
                                          />
                                        )}
                                        {demande?.statut?.code === 'NOUVELLE' && (
                                          <>
                                            {shouldDisplayFonctionnalite(
                                              currentUser,
                                              'MODIFIER DEMANDE DEMONTAGE'
                                            ) && (
                                              <span
                                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                                style={{cursor: 'pointer'}}
                                                data-tooltip-id='tooltip'
                                                data-tooltip-content='Modifier'
                                                data-tooltip-place='right'
                                              >
                                                <i
                                                  className='bi bi-pencil-square fs-2'
                                                  onClick={() => {
                                                    const marqueModele =
                                                      demande?.vehicule?.vehicule?.modele?.marque
                                                        ?.nom +
                                                      ' ' +
                                                      demande?.vehicule?.vehicule?.modele?.nom
                                                    showDemandeDemontageModifModal(
                                                      demande?.id,
                                                      demande?.vehicule?.numero,
                                                      marqueModele,
                                                      demande,
                                                      demande?.demandeTypePiece[0]?.clientDemande?.id ?? null
                                                    )
                                                  }}
                                                ></i>
                                              </span>
                                            )}
                                            {shouldDisplayFonctionnalite(
                                              currentUser,
                                              'VALIDER-REFUSER DEMANDE DEMONTAGE'
                                            ) && (
                                              <span
                                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                                style={{cursor: 'pointer'}}
                                                data-tooltip-id='tooltip'
                                                data-tooltip-content='Valider/Refuser'
                                                data-tooltip-place='right'
                                              >
                                                <i
                                                  className='bi bi-check-circle fs-2'
                                                  onClick={() => {
                                                    showDemandeDemontageValidationModal(demande?.id)
                                                  }}
                                                ></i>
                                              </span>
                                            )}
                                            {shouldDisplayFonctionnalite(
                                              currentUser,
                                              'ANNULER DEMANDE DEMONTAGE'
                                            ) && (
                                              <span
                                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                                style={{cursor: 'pointer'}}
                                                data-tooltip-id='tooltip'
                                                data-tooltip-content='Annuler'
                                                data-tooltip-place='right'
                                              >
                                                <img
                                                  src='/media/svg/custom/cancel-line.svg'
                                                  width={19}
                                                  className='mx-2 cancel'
                                                  onClick={() => {
                                                    showDemandeDemontageAnnulationModal(demande?.id)
                                                  }}
                                                ></img>
                                              </span>
                                            )}
                                          </>
                                        )}
                                        {shouldDisplayFonctionnalite(
                                          currentUser,
                                          'REALISER DEMONTAGE'
                                        ) &&
                                          (demande?.statut?.code === 'VALIDE' ||
                                            demande?.statut?.code === 'EN COURS') && (
                                            <span
                                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                              data-tooltip-id='tooltip'
                                              data-tooltip-content='Réaliser la demande'
                                              data-tooltip-place='left'
                                            >
                                              <Link
                                                to={`/demande-demontage/${demande?.id}/realisation/${demande?.vehicule?.id}`}
                                              >
                                                <img src='/media/svg/custom/File add.svg' width='25' />
                                              </Link>
                                            </span>
                                          )}
                                        <span
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                          style={{cursor: 'pointer'}}
                                          data-tooltip-id='tooltip'
                                          data-tooltip-content="Voir l'historique"
                                          data-tooltip-place='right'
                                        >
                                          <i
                                            className='bi bi-eye fs-2'
                                            onClick={() => viewHistory(demande.id)}
                                          ></i>
                                        </span>
                                      </div>
                                    </td>
                                  </tr>
                                </>
                              )
                            })
                          ) : (
                            <tr>
                              <td colSpan={9} className='text-center'>
                                Aucun résultat trouvé
                              </td>
                            </tr>
                          )}
                        </tbody>
                        {/* end::Table body */}
                      </table>
                      {/* end::Table */}
                    </div>
                    {/* end::Table container */}

                    {/* begin::pagination*/}
                    <Pagination
                      totalPages={totalPages}
                      nombreDePages={nombreDePages}
                      currentPage={currentPage}
                      setCurrentPage={(page) => {
                        setCurrentPage(page)
                        sessionStorage.setItem('demontagePage', String(page))
                      }}
                      locationState={0}
                    />
                    {/* end::pagination*/}
                    {/*Affichage du tooltip*/}
                    <Tooltip id='tooltip' />
                  </div>
                </>
              </>
            )}
          </div>
        </div>
        {/* end::Col  */}
      </div>
      {/* end::Row  */}
      {openDemandeDemontageValidationModal && (
        <DemandeDemontageValidationModal
          show={openDemandeDemontageValidationModal}
          demandeDemontageId={demandeDemontageId}
          showModal={toggleShowDemandeDemontageValidationModal}
          data={data}
          setData={setData}
        />
      )}
      {openDemandeDemontageModifModal && (
        <DemandeDemontageModal
          show={openDemandeDemontageModifModal}
          vehiculeId={vehiculeId}
          numeroVehicule={numero}
          showModal={toggleShowDemandeDemontageModifModal}
          isEdition={true}
          demandeDemontageId={demandeDemontageId}
          setData={setData}
          marqueModele={marqueModele}
          typePiece={null}
          isRedirection={false}
          demandeId={demandeClient}
          typePieceHn={null}
          pieceInstance={null}
        />
      )}
      {openDemandeDemontageAnnulationModal && (
        <DemandeDemontageAnnulationModal
          show={openDemandeDemontageAnnulationModal}
          showModal={toggleShowDemandeDemontageAnnulationModal}
          demandeDemontageId={demandeDemontageId}
          data={data}
          setData={setData}
        />
      )}
    </>
  )
}

export {DemandeDemontageListPage}
